export default "__VITE_ASSET__DCB74$Hy__"